import { render, staticRenderFns } from "./AudioSlider.vue?vue&type=template&id=b18f3660&scoped=true&"
import script from "./AudioSlider.vue?vue&type=script&lang=js&"
export * from "./AudioSlider.vue?vue&type=script&lang=js&"
import style0 from "./AudioSlider.vue?vue&type=style&index=0&id=b18f3660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f3660",
  null
  
)

export default component.exports